import Color from '../Color.mjs'
import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_BLUE,
    codeProp: 'wfUserCode',
    mapProp: 'demoMap',
    name: '流程图',
    ownerIdProp: 'bfId',
    ownerTextProp: 'bfName',
    ownerType: 'BF',
    textProp: 'wfName',
    type: 'WF',
}